var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.readonly')}},[_c('el-switch',{model:{value:(_vm.optionModel.readonly),callback:function ($$v) {_vm.$set(_vm.optionModel, "readonly", $$v)},expression:"optionModel.readonly"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }